<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form
      class="form"
      :class="submitting ? 'is-submitting' : ''"
      @submit.prevent="handleSubmit(submit)"
    >
      <div class="form__error" v-if="serverError">
        {{ serverError }}
      </div>

      <div class="form__fields">
        <b-vee-input
          rules="required"
          :label="$t('Nome')"
          v-model="fields.username"
          :placeholder="$t('Primeiro e último')"
        />

        <b-vee-input
          rules="required|email"
          type="email"
          :label="$t('Email')"
          v-model="fields.email"
          :placeholder="$t('email@domain.com')"
        />

        <b-vee-input
          rules="required"
          type="password"
          :label="$t('Password')"
          vid="password"
          v-model="fields.password"
        />

        <b-vee-input
          rules="required|confirmed:password"
          name="Password"
          type="password"
          :label="$t('Confirme Password')"
          v-model="fields.confirmPassword"
        />

        <b-vee-input
          rules="required"
          :label="$t('Empresa')"
          v-model="fields.company"
          :placeholder="$t('Nome da empresa')"
        />

        <b-vee-input
          rules="required"
          :label="$t('País')"
          v-model="fields.country"
          :placeholder="$t('Seleccione uma opção')"
        />

        <div class="form__accept_terms_row">
          <b-vee-checkbox rules="required" v-model="fields.acceptedTerms">
            {{ $t("Li e concordo com os termos e condições") }}
          </b-vee-checkbox>
        </div>
      </div>

      <div class="u-df u-jcfe u-aic">
        <b-button
          :loading="submitting"
          native-type="submit"
          type="is-primary"
          size="is-medium"
        >
          {{ $t("Registar") }}
        </b-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import store from "@/store";

import { ValidationObserver } from "vee-validate";

import BVeeInput from "./buefy-vee-fields/BVeeInput";
import BVeeSelect from "./buefy-vee-fields/BVeeSelect";
import BVeeCheckbox from "./buefy-vee-fields/BVeeCheckbox";

export default {
  components: {
    ValidationObserver,
    BVeeInput,
    BVeeSelect,
    BVeeCheckbox,
  },

  data() {
    return {
      serverError: null,
      submitting: false,

      fields: {
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        company: "",
        country: "",
        acceptedTerms: false,
        // username: 'Banana',
        // email: 'aasdasd@gmail.com',
        // password: 'jkl',
        // confirmPassword: 'jkl',
        // company: 'k2c',
        // country: 1,
        // acceptedTerms: true,
      },
    };
  },

  computed: {
    countries() {
      return store.state.countries || [];
    },
  },

  methods: {
    submit() {
      this.submitting = true;
      this.serverError = null;

      store
        .dispatch("createAccount", { ...this.fields })
        .then(() => {
          const { email, password } = this.fields;
          this.$emit("success", { email, password });
        })
        .catch((err) => {
          try {
            this.serverError = err.details.messages.email;
          } catch (err) {
            this.serverError = "Erro não definido";
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },

  created() {
    store.dispatch("fetchCountries");
  },
};
</script>

<style lang="scss" scoped>
.form__accept_terms_row {
  margin-top: 1.4em;
}
</style>
